import { Button, Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { Link } from "react-router";

import MessagesIllustrationSVG from "@/../../hypetrain/static/img/messages-illustration.svg";
import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";

const Container = styled(Flex)`
  border-radius: 10px;
  background: linear-gradient(110deg, #fff 49.8%, #f1faff 100.04%);
  box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
`;

const Title = styled(Box)`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: ${Colors.DARK_GRAY1};
`;

const Description = styled(Box)`
  font-size: 16px;
  color: ${Colors.GRAY1};
  text-align: center;
  max-width: 450px;
  line-height: 1.5;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  display: block;
`;

const BrowseButton = styled(Button)`
  border-radius: 4px;
  height: 48px;
  font-size: 16px;
  font-weight: 500;
`;

export function EmptyState({ isCoach }: { isCoach: boolean }) {
  return (
    <Container
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      p={4}
    >
      <Box mb={4}>
        <EmbedSvg src={MessagesIllustrationSVG} />
      </Box>

      <Title mb={2}>Welcome to Your Coaching Message Center</Title>

      <Description mb={4}>
        This is where all your coaching conversations happen. Direct message
        your coaches and have session-specific discussions, all in one organized
        space.
      </Description>

      <Box width="100%" maxWidth="300px">
        <StyledLink to={isCoach ? "/dashboard" : "/match"}>
          <BrowseButton intent="primary" fill large>
            {isCoach ? "Back to Dashboard" : "Browse Coaches"}
          </BrowseButton>
        </StyledLink>
      </Box>
    </Container>
  );
}
